import { InfoOutlineIcon } from "@chakra-ui/icons";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import { maybePluralize } from "src/services/format";

export const SegmentedMessageStats: React.FC<{
  characterCount: number;
  segmentCount: number;
  isOverflowing: boolean;
  characterLimit: number;
  isUCS2: boolean;
}> = ({
  characterCount,
  segmentCount,
  isOverflowing,
  characterLimit,
  isUCS2,
}) => {
  return (
    <Flex justify="space-between" fontSize="sm">
      <Text color={isOverflowing ? "red" : "black"}>
        {characterCount}/{characterLimit}
      </Text>

      <Box display="flex" alignItems="center" gap={2}>
        <Text color={isOverflowing ? "red" : "black"}>
          {segmentCount} {maybePluralize(segmentCount, "segment")}
        </Text>
        <Tooltip
          label={
            <Text align="center">
              Character limits vary by language, special characters (like emojis
              or smart quotes), and personalization variables.
            </Text>
          }
          hasArrow
          placement="top"
          borderRadius="md"
        >
          <InfoOutlineIcon
            aria-label="Character limit information"
            color={isOverflowing ? "red" : "gray.700"}
          />
        </Tooltip>
      </Box>
    </Flex>
  );
};
